import { admin } from './PhpHandler.svelte'
import * as imageConversion from 'image-conversion'
import { storeUploader, storeRemainingStorage, storeMailImages, storeData } from './Store.svelte'
import { get_file_size } from './utils'

// upload and delete for rooms
export async function upload_image(folder, file) {
	//create the image object from the sended file (add the image path)
	let imageObject = file.files[0]

	// path is also the name of the image!! (in formData->imagename)
	let path = file.files[0].name
	imageObject.path = path

	//the large image
	const LARGEHEIGHT = 400
	const LARGEWIDTH = 600

	//medium image
	const MEDIUMHEIGHT = 300
	const MEDIUMWIDTH = 450

	//small image
	const SMALLHEIGHT = 100
	const SMALLWIDTH = 150

	//the thumbnail
	const THUMBHEIGHT = 60
	const THUMBWIDTH = 90

	const pfx = imageObject.path.split('.')

	let reader = new FileReader()

	reader.readAsDataURL(imageObject)

	reader.onload = () => {
		let image = new Image()
		image.src = reader.result
		image.onload = async () => {
			//scale the image to its maxwidth
			let scaleLargeWidth = LARGEWIDTH / image.width
			let scaleLargeHeight = LARGEHEIGHT / image.height
			let scaleMediumWidth = MEDIUMWIDTH / image.width
			let scaleMediumHeight = MEDIUMHEIGHT / image.height
			let scaleSmallWidth = SMALLWIDTH / image.width
			let scaleSmallHeight = SMALLHEIGHT / image.height
			let scaleThumbWidth = THUMBWIDTH / image.width
			let scaleThumbHeight = THUMBHEIGHT / image.height

			let canvasLarge = document.createElement('canvas')
			let ctxLarge = canvasLarge.getContext('2d')
			let canvasMedium = document.createElement('canvas')
			let ctxMedium = canvasMedium.getContext('2d')
			let canvasSmall = document.createElement('canvas')
			let ctxSmall = canvasSmall.getContext('2d')
			let canvasThumb = document.createElement('canvas')
			let ctxThumb = canvasThumb.getContext('2d')

			if (image.width > image.height) {
				canvasLarge.width = LARGEWIDTH
				canvasLarge.height = image.height * scaleLargeWidth
				canvasMedium.width = MEDIUMWIDTH
				canvasMedium.height = image.height * scaleMediumWidth
				canvasSmall.width = SMALLWIDTH
				canvasSmall.height = image.height * scaleSmallWidth
				canvasThumb.width = THUMBWIDTH
				canvasThumb.height = image.height * scaleThumbWidth
			}

			if (image.width < image.height || image.width === image.height) {
				canvasLarge.height = LARGEHEIGHT
				canvasLarge.width = image.width * scaleLargeHeight
				canvasMedium.height = MEDIUMHEIGHT
				canvasMedium.width = image.width * scaleMediumHeight
				canvasSmall.height = SMALLHEIGHT
				canvasSmall.width = image.width * scaleSmallHeight
				canvasThumb.height = THUMBHEIGHT
				canvasThumb.width = image.width * scaleThumbHeight
			}

			ctxLarge.drawImage(image, 0, 0, canvasLarge.width, canvasLarge.height)
			ctxMedium.drawImage(image, 0, 0, canvasMedium.width, canvasMedium.height)
			ctxSmall.drawImage(image, 0, 0, canvasSmall.width, canvasSmall.height)
			ctxThumb.drawImage(image, 0, 0, canvasThumb.width, canvasThumb.height)

			const largeFile = imageConversion.canvastoFile(canvasLarge, {
				quality: 1,
				type: 'image/' + pfx[1],
			})

			largeFile.then((largeValue) => {
				const compressLarge = imageConversion.compressAccurately(largeValue, {
					quality: 0.8,
					type: 'image/' + pfx[1],
					width: canvasLarge.width,
					height: canvasLarge.height,
					orientation: 0,
					scale: 1,
				})

				compressLarge.then((largeValue) => {
					const largeUrl = imageConversion.filetoDataURL(largeValue)

					largeUrl.then((decodeLarge) => {
						//start the medium image
						const mediumFile = imageConversion.canvastoFile(canvasMedium, {
							quality: 1,
							type: 'image/' + pfx[1],
						})
						mediumFile.then((mediumValue) => {
							const compressMedium = imageConversion.compressAccurately(mediumValue, {
								quality: 1,
								type: 'image/' + pfx[1],
								width: canvasMedium.width,
								height: canvasMedium.height,
								orientation: 0,
								scale: 1,
							})

							compressMedium.then((compMedium) => {
								const mediumUrl = imageConversion.filetoDataURL(compMedium)

								mediumUrl.then((decodeMedium) => {
									//start the small image
									const smallFile = imageConversion.canvastoFile(canvasSmall, {
										quality: 1,
										type: 'image/' + pfx[1],
									})

									smallFile.then((smallValue) => {
										const compressSmall = imageConversion.compressAccurately(smallValue, {
											quality: 1,
											type: 'image/' + pfx[1],
											width: canvasSmall.width,
											height: canvasSmall.height,
											orientation: 0,
											scale: 1,
										})

										compressSmall.then((compSmall) => {
											const smallUrl = imageConversion.filetoDataURL(compSmall)

											smallUrl.then((decodeSmall) => {
												//start thumbnail
												const thumbFile = imageConversion.canvastoFile(canvasThumb, {
													quality: 1,
													type: 'image/' + pfx[1],
												})

												thumbFile.then((thumbValue) => {
													const compressThumb = imageConversion.compressAccurately(thumbValue, {
														quality: 1,
														type: 'image/' + pfx[1],
														width: canvasThumb.width,
														height: canvasThumb.height,
														orientation: 0,
														scale: 1,
													})

													compressThumb.then((thumbValue) => {
														const thumbUrl = imageConversion.filetoDataURL(thumbValue)
														thumbUrl.then((decodeThumb) => {
															const imgUpload = {
																name: path,
																large: decodeLarge,
																medium: decodeMedium,
																small: decodeSmall,
																thumb: decodeThumb,
															}

															const formData = {
																cmd: 'uploadImage',
																blockname: folder,
																images: imgUpload,
															}

															const response = admin(formData)

															response.then((v) => {
																response.then((cv) => {
																	const totalStorage = get_file_size()
																	totalStorage.then((sv) => {
																		storeRemainingStorage.set(sv)
																		storeUploader.set(false)
																	})
																})
															})
														})
													})
												})
											})
										}) // close small to url
									}) //close small compress
								}) //close medium canvas to file
							}) //close medium compress
						}) //close medium file to url
					}) // close large canvas to file
				}) //close large compress
			}) //close large file to url
		}
	}
}

export async function upload_mail_image(id, file) {
	//create the image object from the sended file (add the image path)
	let path = file.files[0].name
	file.path = path

	//the large image
	const LARGEHEIGHT = 300
	const LARGEWIDTH = 450

	//medium image
	const MEDIUMHEIGHT = 120
	const MEDIUMWIDTH = 160

	//small image
	const SMALLHEIGHT = 80
	const SMALLWIDTH = 120

	//the thumbnail
	const THUMBHEIGHT = 60
	const THUMBWIDTH = 90

	const pfx = file.path.split('.')

	let reader = new FileReader()
	reader.readAsDataURL(file.files[0])

	reader.onload = () => {
		let image = new Image()
		image.src = reader.result
		image.onload = async () => {
			//scale the image to its maxwidth
			//scale the image to its maxwidth
			let scaleLargeWidth = LARGEWIDTH / image.width
			let scaleLargeHeight = LARGEHEIGHT / image.height
			let scaleMediumWidth = MEDIUMWIDTH / image.width
			let scaleMediumHeight = MEDIUMHEIGHT / image.height
			let scaleSmallWidth = SMALLWIDTH / image.width
			let scaleSmallHeight = SMALLHEIGHT / image.height
			let scaleThumbWidth = THUMBWIDTH / image.width
			let scaleThumbHeight = THUMBHEIGHT / image.height

			let canvasLarge = document.createElement('canvas')
			let ctxLarge = canvasLarge.getContext('2d')
			let canvasMedium = document.createElement('canvas')
			let ctxMedium = canvasMedium.getContext('2d')
			let canvasSmall = document.createElement('canvas')
			let ctxSmall = canvasSmall.getContext('2d')
			let canvasThumb = document.createElement('canvas')
			let ctxThumb = canvasThumb.getContext('2d')

			if (image.width > image.height) {
				canvasLarge.width = LARGEWIDTH
				canvasLarge.height = image.height * scaleLargeWidth
				canvasMedium.width = MEDIUMWIDTH
				canvasMedium.height = image.height * scaleMediumWidth
				canvasSmall.width = SMALLWIDTH
				canvasSmall.height = image.height * scaleSmallWidth
				canvasThumb.width = THUMBWIDTH
				canvasThumb.height = image.height * scaleThumbWidth
			}

			if (image.width < image.height || image.width === image.height) {
				canvasLarge.height = LARGEHEIGHT
				canvasLarge.width = image.width * scaleLargeHeight
				canvasMedium.height = MEDIUMHEIGHT
				canvasMedium.width = image.width * scaleMediumHeight
				canvasSmall.height = SMALLHEIGHT
				canvasSmall.width = image.width * scaleSmallHeight
				canvasThumb.height = THUMBHEIGHT
				canvasThumb.width = image.width * scaleThumbHeight
			}

			ctxLarge.drawImage(image, 0, 0, canvasLarge.width, canvasLarge.height)
			ctxMedium.drawImage(image, 0, 0, canvasMedium.width, canvasMedium.height)
			ctxSmall.drawImage(image, 0, 0, canvasSmall.width, canvasSmall.height)
			ctxThumb.drawImage(image, 0, 0, canvasThumb.width, canvasThumb.height)

			const largeFile = imageConversion.canvastoFile(canvasLarge, {
				quality: 1,
				type: 'image/' + pfx[1],
			})

			largeFile.then((largeValue) => {
				const compressLarge = imageConversion.compressAccurately(largeValue, {
					quality: 0.8,
					type: 'image/' + pfx[1],
					width: canvasLarge.width,
					height: canvasLarge.height,
					orientation: 0,
					scale: 1,
				})

				compressLarge.then((largeValue) => {
					const largeUrl = imageConversion.filetoDataURL(largeValue)

					largeUrl.then((decodeLarge) => {
						//start the medium image
						const mediumFile = imageConversion.canvastoFile(canvasMedium, {
							quality: 1,
							type: 'image/' + pfx[1],
						})
						mediumFile.then((mediumValue) => {
							const compressMedium = imageConversion.compressAccurately(mediumValue, {
								quality: 1,
								type: 'image/' + pfx[1],
								width: canvasMedium.width,
								height: canvasMedium.height,
								orientation: 0,
								scale: 1,
							})

							compressMedium.then((compMedium) => {
								const mediumUrl = imageConversion.filetoDataURL(compMedium)

								mediumUrl.then((decodeMedium) => {
									//start the small image
									const smallFile = imageConversion.canvastoFile(canvasSmall, {
										quality: 1,
										type: 'image/' + pfx[1],
									})

									smallFile.then((smallValue) => {
										const compressSmall = imageConversion.compressAccurately(smallValue, {
											quality: 1,
											type: 'image/' + pfx[1],
											width: canvasSmall.width,
											height: canvasSmall.height,
											orientation: 0,
											scale: 1,
										})

										compressSmall.then((compSmall) => {
											const smallUrl = imageConversion.filetoDataURL(compSmall)

											smallUrl.then((decodeSmall) => {
												//start thumbnail
												const thumbFile = imageConversion.canvastoFile(canvasThumb, {
													quality: 1,
													type: 'image/' + pfx[1],
												})

												thumbFile.then((thumbValue) => {
													const compressThumb = imageConversion.compressAccurately(thumbValue, {
														quality: 1,
														type: 'image/' + pfx[1],
														width: canvasThumb.width,
														height: canvasThumb.height,
														orientation: 0,
														scale: 1,
													})

													compressThumb.then((thumbValue) => {
														const thumbUrl = imageConversion.filetoDataURL(thumbValue)
														thumbUrl.then((decodeThumb) => {
															const imgUpload = {
																name: file.path,
																large: decodeLarge,
																medium: decodeMedium,
																small: decodeSmall,
																thumb: decodeThumb,
															}

															const formData = {
																cmd: 'upload_mail_image',
																id: id,
																images: imgUpload,
															}

															const response = admin(formData)

															if (id !== 'admin') {
																response.then((v) => {
																	response.then((cv) => {
																		storeMailImages.set(true)
																		const totalStorage = get_file_size()
																		totalStorage.then((sv) => {
																			storeRemainingStorage.set(sv)
																			// storeUploader.set(false)
																		})
																	})
																})
															}
															if (id === 'admin') {
																response.then((v) => {
																	// storeUploader.set(false)
																	storeMailImages.set(true)
																})
															}
														})
													})
												})
											})
										}) // close small to url
									}) //close small compress
								}) //close medium canvas to file
							}) //close medium compress
						}) //close medium file to url
					}) // close large canvas to file
				}) //close large compress
			}) //close large file to url
		}
	}
}

export async function delete_image(folder, image) {
	const formData = {
		cmd: 'delete_image',
		folder: folder,
		image: image,
	}

	const response = await admin(formData)
	if (response.filesize > 0) {
		//get the file-size
		const fileSize = get_file_size()
		fileSize.then((value) => {
			storeRemainingStorage.set(value)
		})
		return true
	}
	return formData
}

export async function upload_social(id, file) {
	const response = await admin({ cmd: 'upload_social', id: id, object: file })
	storeData.set(response)
	return true
}
